var _excluded = ["children"],
    _excluded2 = ["container"],
    _excluded3 = ["container"],
    _excluded4 = ["to", "from"],
    _excluded5 = ["root", "once", "amount"],
    _excluded6 = ["children"],
    _excluded7 = ["items", "children"],
    _excluded8 = ["items", "children"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/hooks/useChain.ts
import { each, useIsomorphicLayoutEffect } from "@react-spring/shared"; // src/helpers.ts

import { is, toArray, eachProp, getFluidValue, isAnimatedString, Globals as G } from "@react-spring/shared";

function callProp(value) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(value) ? value(...args) : value;
}

var matchProp = (value, key) => value === true || !!(key && value && (is.fun(value) ? value(key) : toArray(value).includes(key)));

var resolveProp = (prop, key) => is.obj(prop) ? key && prop[key] : prop;

var getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;

var noopTransform = value => value;

var getDefaultProps = function getDefaultProps(props) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopTransform;
  var keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  var defaults2 = {};

  for (var key of keys) {
    var value = transform(props[key], key);

    if (!is.und(value)) {
      defaults2[key] = value;
    }
  }

  return defaults2;
};

var DEFAULT_PROPS = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};

function getForwardProps(props) {
  var forward = {};
  var count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}

function inferTo(props) {
  var to2 = getForwardProps(props);

  if (to2) {
    var out = {
      to: to2
    };
    eachProp(props, (val, key) => key in to2 || (out[key] = val));
    return out;
  }

  return _objectSpread({}, props);
}

function computeGoal(value) {
  value = getFluidValue(value);
  return is.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? G.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}

function hasProps(props) {
  for (var _ in props) {
    return true;
  }

  return false;
}

function isAsyncTo(to2) {
  return is.fun(to2) || is.arr(to2) && is.obj(to2[0]);
}

function detachRefs(ctrl, ref) {
  var _ctrl$ref;

  (_ctrl$ref = ctrl.ref) === null || _ctrl$ref === void 0 ? void 0 : _ctrl$ref.delete(ctrl);
  ref === null || ref === void 0 ? void 0 : ref.delete(ctrl);
}

function replaceRef(ctrl, ref) {
  if (ref && ctrl.ref !== ref) {
    var _ctrl$ref2;

    (_ctrl$ref2 = ctrl.ref) === null || _ctrl$ref2 === void 0 ? void 0 : _ctrl$ref2.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
} // src/hooks/useChain.ts


function useChain(refs, timeSteps) {
  var timeFrame = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1e3;
  useIsomorphicLayoutEffect(() => {
    if (timeSteps) {
      var prevDelay = 0;
      each(refs, (ref, i) => {
        var controllers = ref.current;

        if (controllers.length) {
          var delay = timeFrame * timeSteps[i];
          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          each(controllers, ctrl => {
            each(ctrl.queue, props => {
              var memoizedDelayProp = props.delay;

              props.delay = key => delay + callProp(memoizedDelayProp || 0, key);
            });
          });
          ref.start();
        }
      });
    } else {
      var p = Promise.resolve();
      each(refs, ref => {
        var controllers = ref.current;

        if (controllers.length) {
          var queues = controllers.map(ctrl => {
            var q = ctrl.queue;
            ctrl.queue = [];
            return q;
          });
          p = p.then(() => {
            each(controllers, (ctrl, i) => each(queues[i] || [], update2 => ctrl.queue.push(update2)));
            return Promise.all(ref.start());
          });
        }
      });
    }
  });
} // src/hooks/useSpring.ts


import { is as is9 } from "@react-spring/shared"; // src/hooks/useSprings.ts

import { useContext as useContext2, useMemo, useRef } from "react";
import { is as is8, each as each5, usePrev, useOnce, useForceUpdate, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect2 } from "@react-spring/shared"; // src/SpringValue.ts

import { is as is5, raf as raf3, each as each2, isEqual, toArray as toArray2, eachProp as eachProp3, frameLoop as frameLoop2, flushCalls, getFluidValue as getFluidValue2, isAnimatedString as isAnimatedString2, Globals as G5, callFluidObservers as callFluidObservers2, hasFluidValue, addFluidObserver, removeFluidObserver, getFluidObservers } from "@react-spring/shared";
import { AnimatedValue, AnimatedString, getPayload, getAnimated as getAnimated2, setAnimated, getAnimatedType } from "@react-spring/animated"; // src/AnimationConfig.ts

import { is as is2, easings } from "@react-spring/shared"; // src/constants.ts

var config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
}; // src/AnimationConfig.ts

var defaults = _objectSpread(_objectSpread({}, config.default), {}, {
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
});

var AnimationConfig = class {
  constructor() {
    /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */
    this.velocity = 0;
    Object.assign(this, defaults);
  }

};

function mergeConfig(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = _objectSpread({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = _objectSpread(_objectSpread({}, defaultConfig), newConfig);
  }

  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);

  for (var key in defaults) {
    if (config2[key] == null) {
      config2[key] = defaults[key];
    }
  }

  var {
    frequency,
    damping
  } = config2;
  var {
    mass
  } = config2;

  if (!is2.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config2;
}

function sanitizeConfig(config2, props) {
  if (!is2.und(props.decay)) {
    config2.duration = void 0;
  } else {
    var isTensionConfig = !is2.und(props.tension) || !is2.und(props.friction);

    if (isTensionConfig || !is2.und(props.frequency) || !is2.und(props.damping) || !is2.und(props.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }

    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
} // src/Animation.ts


var emptyArray = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
  }

}; // src/scheduleProps.ts

import { is as is3, raf, Globals as G2 } from "@react-spring/shared";

function scheduleProps(callId, _ref) {
  var {
    key,
    props,
    defaultProps,
    state,
    actions
  } = _ref;
  return new Promise((resolve, reject) => {
    var _props$cancel;

    var delay;
    var timeout;
    var cancel = matchProp((_props$cancel = props.cancel) !== null && _props$cancel !== void 0 ? _props$cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);

    if (cancel) {
      onStart();
    } else {
      if (!is3.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }

      var pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;

      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }

      delay = callProp(props.delay || 0, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }

    function onResume() {
      if (delay > 0 && !G2.skipAnimation) {
        state.delayed = true;
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }

    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }

      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(_objectSpread(_objectSpread({}, props), {}, {
          callId,
          cancel
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
} // src/runAsync.ts


import { is as is4, raf as raf2, flush, eachProp as eachProp2, Globals as G3 } from "@react-spring/shared"; // src/AnimationResult.ts

var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target.get()) : results.every(result => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every(result => result.finished));

var getNoopResult = value => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});

var getFinishedResult = function getFinishedResult(value, finished) {
  var cancelled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    value,
    finished,
    cancelled
  };
};

var getCancelledResult = value => ({
  value,
  cancelled: true,
  finished: false
}); // src/runAsync.ts


function runAsync(to2, props, state, target) {
  var {
    callId,
    parentId,
    onRest
  } = props;
  var {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to2 === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = _asyncToGenerator(function* () {
    state.asyncId = callId;
    state.asyncTo = to2;
    var defaultProps = getDefaultProps(props, (value, key) => // The `onRest` prop is only called when the `runAsync` promise is resolved.
    key === "onRest" ? void 0 : value);
    var preventBail;
    var bail;
    var bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));

    var bailIfEnded = bailSignal => {
      var bailResult = // The `cancel` prop or `stop` method was used.
      callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
      callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };

    var animate = (arg1, arg2) => {
      var bailSignal = new BailSignal();
      var skipAnimationSignal = new SkipAnimationSignal();
      return _asyncToGenerator(function* () {
        if (G3.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }

        bailIfEnded(bailSignal);
        var props2 = is4.obj(arg1) ? _objectSpread({}, arg1) : _objectSpread(_objectSpread({}, arg2), {}, {
          to: arg1
        });
        props2.parentId = callId;
        eachProp2(defaultProps, (value, key) => {
          if (is4.und(props2[key])) {
            props2[key] = value;
          }
        });
        var result2 = yield target.start(props2);
        bailIfEnded(bailSignal);

        if (state.paused) {
          yield new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result2;
      })();
    };

    var result;

    if (G3.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }

    try {
      var animating;

      if (is4.arr(to2)) {
        animating = function () {
          var _ref4 = _asyncToGenerator(function* (queue) {
            for (var props2 of queue) {
              yield animate(props2);
            }
          });

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }()(to2);
      } else {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }

      yield Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }

    if (is4.fun(onRest)) {
      raf2.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }

    return result;
  })();
}

function stopAsync(state, cancelId) {
  flush(state.timeouts, t => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId) state.cancelId = cancelId;
}

var BailSignal = class extends Error {
  constructor() {
    super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
  }

};
var SkipAnimationSignal = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }

}; // src/FrameValue.ts

import { deprecateInterpolate, frameLoop, FluidValue as FluidValue2, Globals as G4, callFluidObservers } from "@react-spring/shared";
import { getAnimated } from "@react-spring/animated";

var isFrameValue = value => value instanceof FrameValue;

var nextId = 1;
var FrameValue = class extends FluidValue2 {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }
  /** Get the current value */


  get() {
    var node = getAnimated(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */


  to() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return G4.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */


  interpolate() {
    deprecateInterpolate();

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return G4.to(this, args);
  }

  toJSON() {
    return this.get();
  }

  observerAdded(count) {
    if (count == 1) this._attach();
  }

  observerRemoved(count) {
    if (count == 0) this._detach();
  }
  /** Called when the first child is added. */


  _attach() {}
  /** Called when the last child is removed. */


  _detach() {}
  /** Tell our children about our new value */


  _onChange(value) {
    var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */


  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }

    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority
    });
  }

}; // src/SpringPhase.ts

var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;

var hasAnimated = target => (target[$P] & HAS_ANIMATED) > 0;

var isAnimating = target => (target[$P] & IS_ANIMATING) > 0;

var isPaused = target => (target[$P] & IS_PAUSED) > 0;

var setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;

var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED; // src/SpringValue.ts


var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    /** The animation state */

    this.animation = new Animation();
    /** Some props have customizable default values */

    this.defaultProps = {};
    /** The state for `runAsync` calls */

    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The promise resolvers of pending `start` calls */

    this._pendingCalls = /* @__PURE__ */new Set();
    /** The counter for tracking `scheduleProps` calls */

    this._lastCallId = 0;
    /** The last `scheduleProps` call that changed the `to` prop */

    this._lastToId = 0;
    this._memoizedDuration = 0;

    if (!is5.und(arg1) || !is5.und(arg2)) {
      var props = is5.obj(arg1) ? _objectSpread({}, arg1) : _objectSpread(_objectSpread({}, arg2), {}, {
        from: arg1
      });

      if (is5.und(props.default)) {
        props.default = true;
      }

      this.start(props);
    }
  }
  /** Equals true when not advancing on each frame. */


  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }

  get goal() {
    return getFluidValue2(this.animation.to);
  }

  get velocity() {
    var node = getAnimated2(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map(node2 => node2.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */


  get hasAnimated() {
    return hasAnimated(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */


  get isAnimating() {
    return isAnimating(this);
  }
  /**
   * When true, all current and future animations are paused.
   */


  get isPaused() {
    return isPaused(this);
  }
  /**
   *
   *
   */


  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */


  advance(dt) {
    var idle = true;
    var changed = false;
    var anim = this.animation;
    var {
      toValues
    } = anim;
    var {
      config: config2
    } = anim;
    var payload = getPayload(anim.to);

    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray2(getFluidValue2(anim.to));
    }

    anim.values.forEach((node2, i) => {
      if (node2.done) return;
      var to2 = // Animated strings always go from 0 to 1.
      node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      var finished = anim.immediate;
      var position = to2;

      if (!finished) {
        position = node2.lastPosition;

        if (config2.tension <= 0) {
          node2.done = true;
          return;
        }

        var elapsed = node2.elapsedTime += dt;
        var from = anim.fromValues[i];
        var v0 = node2.v0 != null ? node2.v0 : node2.v0 = is5.arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
        var velocity;
        var precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));

        if (!is5.und(config2.duration)) {
          var p = 1;

          if (config2.duration > 0) {
            if (this._memoizedDuration !== config2.duration) {
              this._memoizedDuration = config2.duration;

              if (node2.durationProgress > 0) {
                node2.elapsedTime = config2.duration * node2.durationProgress;
                elapsed = node2.elapsedTime += dt;
              }
            }

            p = (config2.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node2.durationProgress = p;
          }

          position = from + config2.easing(p) * (to2 - from);
          velocity = (position - node2.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          var decay = config2.decay === true ? 0.998 : config2.decay;
          var e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node2.lastPosition - position) <= precision;
          velocity = v0 * e;
        } else {
          velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
          var restVelocity = config2.restVelocity || precision / 10;
          var bounceFactor = config2.clamp ? 0 : config2.bounce;
          var canBounce = !is5.und(bounceFactor);
          var isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
          var isMoving;
          var isBouncing = false;
          var step = 1;
          var numSteps = Math.ceil(dt / step);

          for (var n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;

            if (!isMoving) {
              finished = Math.abs(to2 - position) <= precision;

              if (finished) {
                break;
              }
            }

            if (canBounce) {
              isBouncing = position == to2 || position > to2 == isGrowing;

              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to2;
              }
            }

            var springForce = -config2.tension * 1e-6 * (position - to2);
            var dampingForce = -config2.friction * 1e-3 * velocity;
            var acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }

        node2.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn("Got NaN while animating:", this);
          finished = true;
        }
      }

      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node2.done = true;
      } else {
        idle = false;
      }

      if (node2.setValue(position, config2.round)) {
        changed = true;
      }
    });
    var node = getAnimated2(this);
    var currVal = node.getValue();

    if (idle) {
      var finalVal = getFluidValue2(anim.to);

      if ((currVal !== finalVal || changed) && !config2.decay) {
        node.setValue(finalVal);

        this._onChange(finalVal);
      } else if (changed && config2.decay) {
        this._onChange(currVal);
      }

      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }
  /** Set the current value, while stopping the current animation */


  set(value) {
    raf3.batchedUpdates(() => {
      this._stop();

      this._focus(value);

      this._set(value);
    });
    return this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */


  pause() {
    this._update({
      pause: true
    });
  }
  /** Resume the animation if paused. */


  resume() {
    this._update({
      pause: false
    });
  }
  /** Skip to the end of the current animation. */


  finish() {
    if (isAnimating(this)) {
      var {
        to: to2,
        config: config2
      } = this.animation;
      raf3.batchedUpdates(() => {
        this._onStart();

        if (!config2.decay) {
          this._set(to2, false);
        }

        this._stop();
      });
    }

    return this;
  }
  /** Push props into the pending queue. */


  update(props) {
    var queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }

  start(to2, arg2) {
    var queue;

    if (!is5.und(to2)) {
      queue = [is5.obj(to2) ? to2 : _objectSpread(_objectSpread({}, arg2), {}, {
        to: to2
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    return Promise.all(queue.map(props => {
      var up = this._update(props);

      return up;
    })).then(results => getCombinedResult(this, results));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */


  stop(cancel) {
    var {
      to: to2
    } = this.animation;

    this._focus(this.get());

    stopAsync(this._state, cancel && this._lastCallId);
    raf3.batchedUpdates(() => this._stop(to2, cancel));
    return this;
  }
  /** Restart the animation. */


  reset() {
    this._update({
      reset: true
    });
  }
  /** @internal */


  eventObserved(event) {
    if (event.type == "change") {
      this._start();
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */


  _prepareNode(props) {
    var key = this.key || "";
    var {
      to: to2,
      from
    } = props;
    to2 = is5.obj(to2) ? to2[key] : to2;

    if (to2 == null || isAsyncTo(to2)) {
      to2 = void 0;
    }

    from = is5.obj(from) ? from[key] : from;

    if (from == null) {
      from = void 0;
    }

    var range = {
      to: to2,
      from
    };

    if (!hasAnimated(this)) {
      if (props.reverse) [to2, from] = [from, to2];
      from = getFluidValue2(from);

      if (!is5.und(from)) {
        this._set(from);
      } else if (!getAnimated2(this)) {
        this._set(to2);
      }
    }

    return range;
  }
  /** Every update is processed by this method before merging. */


  _update(_ref5, isLoop) {
    var props = _extends({}, _ref5);

    var {
      key,
      defaultProps
    } = this;
    if (props.default) Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, "onProps");
    sendEvent(this, "onProps", props, this);

    var range = this._prepareNode(props);

    if (Object.isFrozen(this)) {
      throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
    }

    var state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(this, "onPause", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);

            if (isAnimating(this)) {
              this._resume();
            }

            flushCalls(state.resumeQueue);
            sendEvent(this, "onResume", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        var nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }
  /** Merge props into the current animation */


  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    var hasToProp = !is5.und(range.to);
    var hasFromProp = !is5.und(range.from);

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }

    var {
      key,
      defaultProps,
      animation: anim
    } = this;
    var {
      to: prevTo,
      from: prevFrom
    } = anim;
    var {
      to: to2 = prevTo,
      from = prevFrom
    } = range;

    if (hasFromProp && !hasToProp && (!props.default || is5.und(to2))) {
      to2 = from;
    }

    if (props.reverse) [to2, from] = [from, to2];
    var hasFromChanged = !isEqual(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }

    from = getFluidValue2(from);
    var hasToChanged = !isEqual(to2, prevTo);

    if (hasToChanged) {
      this._focus(to2);
    }

    var hasAsyncTo = isAsyncTo(props.to);
    var {
      config: config2
    } = anim;
    var {
      decay,
      velocity
    } = config2;

    if (hasToProp || hasFromProp) {
      config2.velocity = 0;
    }

    if (props.config && !hasAsyncTo) {
      mergeConfig(config2, callProp(props.config, key), // Avoid calling the same "config" prop twice.
      props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }

    var node = getAnimated2(this);

    if (!node || is5.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }

    var reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
    // except for declarative updates. When `reset` is defined, there
    // must exist a value to animate from.
    is5.und(props.reset) ? hasFromProp && !props.default : !is5.und(from) && matchProp(props.reset, key);
    var value = reset ? from : this.get();
    var goal = computeGoal(to2);
    var isAnimatable = is5.num(goal) || is5.arr(goal) || isAnimatedString2(goal);
    var immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      var nodeType = getAnimatedType(to2);

      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else throw Error("Cannot animate between ".concat(node.constructor.name, " and ").concat(nodeType.name, ", as the \"to\" prop suggests"));
      }
    }

    var goalType = node.constructor;
    var started = hasFluidValue(to2);
    var finished = false;

    if (!started) {
      var hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;

      if (hasToChanged || hasValueChanged) {
        finished = isEqual(computeGoal(value), goal);
        started = !finished;
      }

      if (!isEqual(anim.immediate, immediate) && !immediate || !isEqual(config2.decay, decay) || !isEqual(config2.velocity, velocity)) {
        started = true;
      }
    }

    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }

    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray2(goal);
      }

      if (anim.immediate != immediate) {
        anim.immediate = immediate;

        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }

      if (started) {
        var {
          onRest
        } = anim;
        each2(ACTIVE_EVENTS, type => mergeActiveFn(this, props, type));
        var result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);

        this._pendingCalls.add(resolve);

        if (anim.changed) raf3.batchedUpdates(() => {
          anim.changed = !reset;
          onRest === null || onRest === void 0 ? void 0 : onRest(result, this);

          if (reset) {
            callProp(defaultProps.onRest, result);
          } else {
            var _anim$onStart;

            (_anim$onStart = anim.onStart) === null || _anim$onStart === void 0 ? void 0 : _anim$onStart.call(anim, result, this);
          }
        });
      }
    }

    if (reset) {
      this._set(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */


  _focus(value) {
    var anim = this.animation;

    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }

      anim.to = value;

      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }

  _attach() {
    var priority = 0;
    var {
      to: to2
    } = this.animation;

    if (hasFluidValue(to2)) {
      addFluidObserver(to2, this);

      if (isFrameValue(to2)) {
        priority = to2.priority + 1;
      }
    }

    this.priority = priority;
  }

  _detach() {
    var {
      to: to2
    } = this.animation;

    if (hasFluidValue(to2)) {
      removeFluidObserver(to2, this);
    }
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */


  _set(arg) {
    var idle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var value = getFluidValue2(arg);

    if (!is5.und(value)) {
      var oldNode = getAnimated2(this);

      if (!oldNode || !isEqual(value, oldNode.getValue())) {
        var nodeType = getAnimatedType(value);

        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }

        if (oldNode) {
          raf3.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }

    return getAnimated2(this);
  }

  _onStart() {
    var anim = this.animation;

    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }

  _onChange(value, idle) {
    if (!idle) {
      this._onStart();

      callProp(this.animation.onChange, value, this);
    }

    callProp(this.defaultProps.onChange, value, this);

    super._onChange(value, idle);
  } // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.


  _start() {
    var anim = this.animation;
    getAnimated2(this).reset(getFluidValue2(anim.to));

    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    if (!isAnimating(this)) {
      setActiveBit(this, true);

      if (!isPaused(this)) {
        this._resume();
      }
    }
  }

  _resume() {
    if (G5.skipAnimation) {
      this.finish();
    } else {
      frameLoop2.start(this);
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */


  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      var anim = this.animation;
      each2(anim.values, node => {
        node.done = true;
      });

      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }

      callFluidObservers2(this, {
        type: "idle",
        parent: this
      });
      var result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
      flushCalls(this._pendingCalls, result);

      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }

};

function checkFinished(target, to2) {
  var goal = computeGoal(to2);
  var value = computeGoal(target.get());
  return isEqual(value, goal);
}

function createLoopUpdate(props) {
  var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.loop;
  var to2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : props.to;
  var loopRet = callProp(loop);

  if (loopRet) {
    var overrides = loopRet !== true && inferTo(loopRet);
    var reverse = (overrides || props).reverse;
    var reset = !overrides || overrides.reset;
    return createUpdate(_objectSpread(_objectSpread({}, props), {}, {
      loop,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props.from : void 0,
      reset
    }, overrides));
  }
}

function createUpdate(props) {
  var {
    to: to2,
    from
  } = props = inferTo(props);
  var keys = /* @__PURE__ */new Set();
  if (is5.obj(to2)) findDefined(to2, keys);
  if (is5.obj(from)) findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}

function declareUpdate(props) {
  var update2 = createUpdate(props);

  if (is5.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }

  return update2;
}

function findDefined(values, keys) {
  eachProp3(values, (value, key) => value != null && keys.add(key));
}

var ACTIVE_EVENTS = ["onStart", "onRest", "onChange", "onPause", "onResume"];

function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}

function sendEvent(target, type) {
  var _target$animation$typ, _target$animation, _target$defaultProps$, _target$defaultProps;

  for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    args[_key4 - 2] = arguments[_key4];
  }

  (_target$animation$typ = (_target$animation = target.animation)[type]) === null || _target$animation$typ === void 0 ? void 0 : _target$animation$typ.call(_target$animation, ...args);
  (_target$defaultProps$ = (_target$defaultProps = target.defaultProps)[type]) === null || _target$defaultProps$ === void 0 ? void 0 : _target$defaultProps$.call(_target$defaultProps, ...args);
} // src/Controller.ts


import { is as is6, raf as raf4, each as each3, noop, flush as flush2, toArray as toArray3, eachProp as eachProp4, flushCalls as flushCalls2, addFluidObserver as addFluidObserver2 } from "@react-spring/shared";
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller = class {
  constructor(props, flush3) {
    this.id = nextId2++;
    /** The animated values */

    this.springs = {};
    /** The queue of props passed to the `update` method. */

    this.queue = [];
    /** The counter for tracking `scheduleProps` calls */

    this._lastAsyncId = 0;
    /** The values currently being animated */

    this._active = /* @__PURE__ */new Set();
    /** The values that changed recently */

    this._changed = /* @__PURE__ */new Set();
    /** Equals false when `onStart` listeners can be called */

    this._started = false;
    /** State used by the `runAsync` function */

    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */new Set(),
      resumeQueue: /* @__PURE__ */new Set(),
      timeouts: /* @__PURE__ */new Set()
    };
    /** The event queues that are flushed once per frame maximum */

    this._events = {
      onStart: /* @__PURE__ */new Map(),
      onChange: /* @__PURE__ */new Map(),
      onRest: /* @__PURE__ */new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush3) {
      this._flush = flush3;
    }

    if (props) {
      this.start(_objectSpread({
        default: true
      }, props));
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */


  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }

  get item() {
    return this._item;
  }

  set item(item) {
    this._item = item;
  }
  /** Get the current values of our springs */


  get() {
    var values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  /** Set the current values without animating. */


  set(values) {
    for (var key in values) {
      var value = values[key];

      if (!is6.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  /** Push an update onto the queue of each value. */


  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }

    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */


  start(props) {
    var {
      queue
    } = this;

    if (props) {
      queue = toArray3(props).map(createUpdate);
    } else {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** @internal */


  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }

    if (keys) {
      var springs = this.springs;
      each3(toArray3(keys), key => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each(spring => spring.stop(!!arg));
    }

    return this;
  }
  /** Freeze the active animation in time */


  pause(keys) {
    if (is6.und(keys)) {
      this.start({
        pause: true
      });
    } else {
      var springs = this.springs;
      each3(toArray3(keys), key => springs[key].pause());
    }

    return this;
  }
  /** Resume the animation if paused. */


  resume(keys) {
    if (is6.und(keys)) {
      this.start({
        pause: false
      });
    } else {
      var springs = this.springs;
      each3(toArray3(keys), key => springs[key].resume());
    }

    return this;
  }
  /** Call a function once per spring value */


  each(iterator) {
    eachProp4(this.springs, iterator);
  }
  /** @internal Called at the end of every animation frame */


  _onFrame() {
    var {
      onStart,
      onChange,
      onRest
    } = this._events;
    var active = this._active.size > 0;
    var changed = this._changed.size > 0;

    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush2(onStart, _ref6 => {
        var [onStart2, result] = _ref6;
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }

    var idle = !active && this._started;
    var values = changed || idle && onRest.size ? this.get() : null;

    if (changed && onChange.size) {
      flush2(onChange, _ref7 => {
        var [onChange2, result] = _ref7;
        result.value = values;
        onChange2(result, this, this._item);
      });
    }

    if (idle) {
      this._started = false;
      flush2(onRest, _ref8 => {
        var [onRest2, result] = _ref8;
        result.value = values;
        onRest2(result, this, this._item);
      });
    }
  }
  /** @internal */


  eventObserved(event) {
    if (event.type == "change") {
      this._changed.add(event.parent);

      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else return;

    raf4.onFrame(this._onFrame);
  }

};

function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}

function flushUpdate(_x2, _x3, _x4) {
  return _flushUpdate.apply(this, arguments);
}

function _flushUpdate() {
  _flushUpdate = _asyncToGenerator(function* (ctrl, props, isLoop) {
    var {
      keys,
      to: to2,
      from,
      loop,
      onRest,
      onResolve
    } = props;
    var defaults2 = is6.obj(props.default) && props.default;

    if (loop) {
      props.loop = false;
    }

    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    var asyncTo = is6.arr(to2) || is6.fun(to2) ? to2 : void 0;

    if (asyncTo) {
      props.to = void 0;
      props.onRest = void 0;

      if (defaults2) {
        defaults2.onRest = void 0;
      }
    } else {
      each3(BATCHED_EVENTS, key => {
        var handler = props[key];

        if (is6.fun(handler)) {
          var queue = ctrl["_events"][key];

          props[key] = _ref21 => {
            var {
              finished,
              cancelled
            } = _ref21;
            var result2 = queue.get(handler);

            if (result2) {
              if (!finished) result2.finished = false;
              if (cancelled) result2.cancelled = true;
            } else {
              queue.set(handler, {
                value: null,
                finished: finished || false,
                cancelled: cancelled || false
              });
            }
          };

          if (defaults2) {
            defaults2[key] = props[key];
          }
        }
      });
    }

    var state = ctrl["_state"];

    if (props.pause === !state.paused) {
      state.paused = props.pause;
      flushCalls2(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) {
      props.pause = true;
    }

    var promises = (keys || Object.keys(ctrl.springs)).map(key => ctrl.springs[key].start(props));
    var cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;

    if (asyncTo || cancel && state.asyncId) {
      promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
        props,
        state,
        actions: {
          pause: noop,
          resume: noop,

          start(props2, resolve) {
            if (cancel) {
              stopAsync(state, ctrl["_lastAsyncId"]);
              resolve(getCancelledResult(ctrl));
            } else {
              props2.onRest = onRest;
              resolve(runAsync(asyncTo, props2, state, ctrl));
            }
          }

        }
      }));
    }

    if (state.paused) {
      yield new Promise(resume => {
        state.resumeQueue.add(resume);
      });
    }

    var result = getCombinedResult(ctrl, yield Promise.all(promises));

    if (loop && result.finished && !(isLoop && result.noop)) {
      var nextProps = createLoopUpdate(props, loop, to2);

      if (nextProps) {
        prepareKeys(ctrl, [nextProps]);
        return flushUpdate(ctrl, nextProps, true);
      }
    }

    if (onResolve) {
      raf4.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
    }

    return result;
  });
  return _flushUpdate.apply(this, arguments);
}

function getSprings(ctrl, props) {
  var springs = _objectSpread({}, ctrl.springs);

  if (props) {
    each3(toArray3(props), props2 => {
      if (is6.und(props2.keys)) {
        props2 = createUpdate(props2);
      }

      if (!is6.obj(props2.to)) {
        props2 = _objectSpread(_objectSpread({}, props2), {}, {
          to: void 0
        });
      }

      prepareSprings(springs, props2, key => {
        return createSpring(key);
      });
    });
  }

  setSprings(ctrl, springs);
  return springs;
}

function setSprings(ctrl, springs) {
  eachProp4(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver2(spring, ctrl);
    }
  });
}

function createSpring(key, observer) {
  var spring = new SpringValue();
  spring.key = key;

  if (observer) {
    addFluidObserver2(spring, observer);
  }

  return spring;
}

function prepareSprings(springs, props, create) {
  if (props.keys) {
    each3(props.keys, key => {
      var spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}

function prepareKeys(ctrl, queue) {
  each3(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
} // src/SpringContext.tsx


import * as React from "react";
import { useContext } from "react";
import { useMemoOne } from "@react-spring/shared";

var SpringContext = _ref9 => {
  var {
    children
  } = _ref9,
      props = _objectWithoutProperties(_ref9, _excluded);

  var inherited = useContext(ctx);
  var pause = props.pause || !!inherited.pause,
      immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({
    pause,
    immediate
  }), [pause, immediate]);
  var {
    Provider
  } = ctx;
  return /* @__PURE__ */React.createElement(Provider, {
    value: props
  }, children);
};

var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;

function makeContext(target, init) {
  Object.assign(target, React.createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
} // src/SpringRef.ts


import { each as each4, is as is7, deprecateDirectCall } from "@react-spring/shared";

var SpringRef = () => {
  var current = [];

  var SpringRef2 = function SpringRef2(props) {
    deprecateDirectCall();
    var results = [];
    each4(current, (ctrl, i) => {
      if (is7.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = _getProps(props, ctrl, i);

        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };

  SpringRef2.current = current;

  SpringRef2.add = function (ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };

  SpringRef2.delete = function (ctrl) {
    var i = current.indexOf(ctrl);
    if (~i) current.splice(i, 1);
  };

  SpringRef2.pause = function () {
    each4(current, ctrl => ctrl.pause(...arguments));
    return this;
  };

  SpringRef2.resume = function () {
    each4(current, ctrl => ctrl.resume(...arguments));
    return this;
  };

  SpringRef2.set = function (values) {
    each4(current, (ctrl, i) => {
      var update2 = is7.fun(values) ? values(i, ctrl) : values;

      if (update2) {
        ctrl.set(update2);
      }
    });
  };

  SpringRef2.start = function (props) {
    var results = [];
    each4(current, (ctrl, i) => {
      if (is7.und(props)) {
        results.push(ctrl.start());
      } else {
        var update2 = this._getProps(props, ctrl, i);

        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };

  SpringRef2.stop = function () {
    each4(current, ctrl => ctrl.stop(...arguments));
    return this;
  };

  SpringRef2.update = function (props) {
    each4(current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  };

  var _getProps = function _getProps(arg, ctrl, index) {
    return is7.fun(arg) ? arg(index, ctrl) : arg;
  };

  SpringRef2._getProps = _getProps;
  return SpringRef2;
}; // src/hooks/useSprings.ts


function useSprings(length, props, deps) {
  var propsFn = is8.fun(props) && props;
  if (propsFn && !deps) deps = [];
  var ref = useMemo(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  var layoutId = useRef(0);
  var forceUpdate = useForceUpdate();
  var state = useMemo(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates2) {
      var springs2 = getSprings(ctrl, updates2);
      var canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise(resolve => {
        setSprings(ctrl, springs2);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates2));
        });
        forceUpdate();
      });
    }

  }), []);
  var ctrls = useRef([...state.ctrls]);
  var updates = [];
  var prevLength = usePrev(length) || 0;
  useMemo(() => {
    each5(ctrls.current.slice(length, prevLength), ctrl => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    ctrls.current.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);

  function declareUpdates(startIndex, endIndex) {
    for (var i = startIndex; i < endIndex; i++) {
      var ctrl = ctrls.current[i] || (ctrls.current[i] = new Controller(null, state.flush));
      var update2 = propsFn ? propsFn(i, ctrl) : props[i];

      if (update2) {
        updates[i] = declareUpdate(update2);
      }
    }
  }

  var springs = ctrls.current.map((ctrl, i) => getSprings(ctrl, updates[i]));
  var context = useContext2(SpringContext);
  var prevContext = usePrev(context);
  var hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect2(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    var {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      each5(queue, cb => cb());
    }

    each5(ctrls.current, (ctrl, i) => {
      ref === null || ref === void 0 ? void 0 : ref.add(ctrl);

      if (hasContext) {
        ctrl.start({
          default: context
        });
      }

      var update2 = updates[i];

      if (update2) {
        replaceRef(ctrl, update2.ref);

        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(() => () => {
    each5(state.ctrls, ctrl => ctrl.stop(true));
  });
  var values = springs.map(x => _objectSpread({}, x));
  return ref ? [values, ref] : values;
} // src/hooks/useSpring.ts


function useSpring(props, deps) {
  var isFn = is9.fun(props);
  var [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
} // src/hooks/useSpringRef.ts


import { useState } from "react";

var initSpringRef = () => SpringRef();

var useSpringRef = () => useState(initSpringRef)[0]; // src/hooks/useSpringValue.ts


import { useConstant, useOnce as useOnce2 } from "@react-spring/shared";

var useSpringValue = (initial, props) => {
  var springValue = useConstant(() => new SpringValue(initial, props));
  useOnce2(() => () => {
    springValue.stop();
  });
  return springValue;
}; // src/hooks/useTrail.ts


import { each as each6, is as is10, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect3 } from "@react-spring/shared";

function useTrail(length, propsArg, deps) {
  var propsFn = is10.fun(propsArg) && propsArg;
  if (propsFn && !deps) deps = [];
  var reverse = true;
  var passedRef = void 0;
  var result = useSprings(length, (i, ctrl) => {
    var props = propsFn ? propsFn(i, ctrl) : propsArg;
    passedRef = props.ref;
    reverse = reverse && props.reverse;
    return props;
  }, // Ensure the props function is called when no deps exist.
  // This works around the 3 argument rule.
  deps || [{}]);
  useIsomorphicLayoutEffect3(() => {
    each6(result[1].current, (ctrl, i) => {
      var parent = result[1].current[i + (reverse ? 1 : -1)];
      replaceRef(ctrl, passedRef);

      if (ctrl.ref) {
        if (parent) {
          ctrl.update({
            to: parent.springs
          });
        }

        return;
      }

      if (parent) {
        ctrl.start({
          to: parent.springs
        });
      } else {
        ctrl.start();
      }
    });
  }, deps);

  if (propsFn || arguments.length == 3) {
    var _passedRef;

    var ref = (_passedRef = passedRef) !== null && _passedRef !== void 0 ? _passedRef : result[1];

    ref["_getProps"] = (propsArg2, ctrl, i) => {
      var props = is10.fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;

      if (props) {
        var parent = ref.current[i + (props.reverse ? 1 : -1)];
        if (parent) props.to = parent.springs;
        return props;
      }
    };

    return result;
  }

  return result[0];
} // src/hooks/useTransition.tsx


import * as React2 from "react";
import { useContext as useContext3, useRef as useRef2, useMemo as useMemo2 } from "react";
import { is as is11, toArray as toArray4, useForceUpdate as useForceUpdate2, useOnce as useOnce3, usePrev as usePrev2, each as each7, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect4 } from "@react-spring/shared";

function useTransition(data, props, deps) {
  var propsFn = is11.fun(props) && props;
  var {
    reset,
    sort,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props;
  var ref = useMemo2(() => propsFn || arguments.length == 3 ? SpringRef() : void 0, []);
  var items = toArray4(data);
  var transitions = [];
  var usedTransitions = useRef2(null);
  var prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect4(() => {
    usedTransitions.current = transitions;
  });
  useOnce3(() => {
    each7(transitions, t => {
      ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
      t.ctrl.ref = ref;
    });
    return () => {
      each7(usedTransitions.current, t => {
        if (t.expired) {
          clearTimeout(t.expirationId);
        }

        detachRefs(t.ctrl, ref);
        t.ctrl.stop(true);
      });
    };
  });
  var keys = getKeys(items, propsFn ? propsFn() : props, prevTransitions);
  var expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect4(() => each7(expired, _ref10 => {
    var {
      ctrl,
      item,
      key
    } = _ref10;
    detachRefs(ctrl, ref);
    callProp(onDestroyed, item, key);
  }));
  var reused = [];
  if (prevTransitions) each7(prevTransitions, (t, i) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
      expired.push(t);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  });
  each7(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: "mount"
        /* MOUNT */
        ,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });

  if (reused.length) {
    var i = -1;
    var {
      leave
    } = propsFn ? propsFn() : props;
    each7(reused, (keyIndex, prevIndex) => {
      var t = prevTransitions[prevIndex];

      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = _objectSpread(_objectSpread({}, t), {}, {
          item: items[keyIndex]
        });
      } else if (leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }

  if (is11.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }

  var delay = -trail;
  var forceUpdate = useForceUpdate2();
  var defaultProps = getDefaultProps(props);
  var changes = /* @__PURE__ */new Map();
  var exitingTransitions = useRef2( /* @__PURE__ */new Map());
  var forceChange = useRef2(false);
  each7(transitions, (t, i) => {
    var key = t.key;
    var prevPhase = t.phase;
    var p = propsFn ? propsFn() : props;
    var to2;
    var phase;
    var propsDelay = callProp(p.delay || 0, key);

    if (prevPhase == "mount"
    /* MOUNT */
    ) {
      to2 = p.enter;
      phase = "enter"
      /* ENTER */
      ;
    } else {
      var isLeave = keys.indexOf(key) < 0;

      if (prevPhase != "leave"
      /* LEAVE */
      ) {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave"
          /* LEAVE */
          ;
        } else if (to2 = p.update) {
          phase = "update"
          /* UPDATE */
          ;
        } else return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter"
        /* ENTER */
        ;
      } else return;
    }

    to2 = callProp(to2, t.item, i);
    to2 = is11.obj(to2) ? inferTo(to2) : {
      to: to2
    };

    if (!to2.config) {
      var config2 = propsConfig || defaultProps.config;
      to2.config = callProp(config2, t.item, i, phase);
    }

    delay += trail;

    var payload = _objectSpread(_objectSpread({}, defaultProps), {}, {
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false
    }, to2);

    if (phase == "enter"
    /* ENTER */
    && is11.und(payload.from)) {
      var p2 = propsFn ? propsFn() : props;
      var from = is11.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from, t.item, i);
    }

    var {
      onResolve
    } = payload;

    payload.onResolve = result => {
      callProp(onResolve, result);
      var transitions2 = usedTransitions.current;
      var t2 = transitions2.find(t3 => t3.key === key);
      if (!t2) return;

      if (result.cancelled && t2.phase != "update"
      /* UPDATE */
      ) {
        return;
      }

      if (t2.ctrl.idle) {
        var idle = transitions2.every(t3 => t3.ctrl.idle);

        if (t2.phase == "leave"
        /* LEAVE */
        ) {
          var expiry = callProp(expires, t2.item);

          if (expiry !== false) {
            var expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;

            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }

        if (idle && transitions2.some(t3 => t3.expired)) {
          exitingTransitions.current.delete(t2);

          if (exitBeforeEnter) {
            forceChange.current = true;
          }

          forceUpdate();
        }
      }
    };

    var springs = getSprings(t.ctrl, payload);

    if (phase === "leave"
    /* LEAVE */
    && exitBeforeEnter) {
      exitingTransitions.current.set(t, {
        phase,
        springs,
        payload
      });
    } else {
      changes.set(t, {
        phase,
        springs,
        payload
      });
    }
  });
  var context = useContext3(SpringContext);
  var prevContext = usePrev2(context);
  var hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect4(() => {
    if (hasContext) {
      each7(transitions, t => {
        t.ctrl.start({
          default: context
        });
      });
    }
  }, [context]);
  each7(changes, (_, t) => {
    if (exitingTransitions.current.size) {
      var ind = transitions.findIndex(state => state.key === t.key);
      transitions.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect4(() => {
    each7(exitingTransitions.current.size ? exitingTransitions.current : changes, (_ref11, t) => {
      var {
        phase,
        payload
      } = _ref11;
      var {
        ctrl
      } = t;
      t.phase = phase;
      ref === null || ref === void 0 ? void 0 : ref.add(ctrl);

      if (hasContext && phase == "enter"
      /* ENTER */
      ) {
        ctrl.start({
          default: context
        });
      }

      if (payload) {
        replaceRef(ctrl, payload.ref);

        if ((ctrl.ref || ref) && !forceChange.current) {
          ctrl.update(payload);
        } else {
          ctrl.start(payload);

          if (forceChange.current) {
            forceChange.current = false;
          }
        }
      }
    });
  }, reset ? void 0 : deps);

  var renderTransitions = render => /* @__PURE__ */React2.createElement(React2.Fragment, null, transitions.map((t, i) => {
    var {
      springs
    } = changes.get(t) || t.ctrl;
    var elem = render(_objectSpread({}, springs), t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */React2.createElement(elem.type, _objectSpread(_objectSpread({}, elem.props), {}, {
      key: is11.str(t.key) || is11.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));

  return ref ? [renderTransitions, ref] : renderTransitions;
}

var nextKey = 1;

function getKeys(items, _ref12, prevTransitions) {
  var {
    key,
    keys = key
  } = _ref12;

  if (keys === null) {
    var reused = /* @__PURE__ */new Set();
    return items.map(item => {
      var t = prevTransitions && prevTransitions.find(t2 => t2.item === item && t2.phase !== "leave"
      /* LEAVE */
      && !reused.has(t2));

      if (t) {
        reused.add(t);
        return t.key;
      }

      return nextKey++;
    });
  }

  return is11.und(keys) ? items : is11.fun(keys) ? items.map(keys) : toArray4(keys);
} // src/hooks/useScroll.ts


import { each as each8, onScroll, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect5 } from "@react-spring/shared";

var useScroll = function useScroll() {
  var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      {
    container
  } = _ref13,
      springOptions = _objectWithoutProperties(_ref13, _excluded2);

  var [scrollValues, api] = useSpring(() => _objectSpread({
    scrollX: 0,
    scrollY: 0,
    scrollXProgress: 0,
    scrollYProgress: 0
  }, springOptions), []);
  useIsomorphicLayoutEffect5(() => {
    var cleanupScroll = onScroll(_ref14 => {
      var {
        x,
        y
      } = _ref14;
      api.start({
        scrollX: x.current,
        scrollXProgress: x.progress,
        scrollY: y.current,
        scrollYProgress: y.progress
      });
    }, {
      container: (container === null || container === void 0 ? void 0 : container.current) || void 0
    });
    return () => {
      each8(Object.values(scrollValues), value => value.stop());
      cleanupScroll();
    };
  }, []);
  return scrollValues;
}; // src/hooks/useResize.ts


import { onResize, each as each9, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect6 } from "@react-spring/shared";

var useResize = _ref15 => {
  var {
    container
  } = _ref15,
      springOptions = _objectWithoutProperties(_ref15, _excluded3);

  var [sizeValues, api] = useSpring(() => _objectSpread({
    width: 0,
    height: 0
  }, springOptions), []);
  useIsomorphicLayoutEffect6(() => {
    var cleanupScroll = onResize(_ref16 => {
      var {
        width,
        height
      } = _ref16;
      api.start({
        width,
        height,
        immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
      });
    }, {
      container: (container === null || container === void 0 ? void 0 : container.current) || void 0
    });
    return () => {
      each9(Object.values(sizeValues), value => value.stop());
      cleanupScroll();
    };
  }, []);
  return sizeValues;
}; // src/hooks/useInView.ts


import { useRef as useRef3, useState as useState2 } from "react";
import { is as is12, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect7 } from "@react-spring/shared";
var defaultThresholdOptions = {
  any: 0,
  all: 1
};

function useInView(props, args) {
  var [isInView, setIsInView] = useState2(false);
  var ref = useRef3();
  var propsFn = is12.fun(props) && props;
  var springsProps = propsFn ? propsFn() : {};

  var {
    to: to2 = {},
    from = {}
  } = springsProps,
      restSpringProps = _objectWithoutProperties(springsProps, _excluded4);

  var intersectionArguments = propsFn ? args : props;
  var [springs, api] = useSpring(() => _objectSpread({
    from
  }, restSpringProps), []);
  useIsomorphicLayoutEffect7(() => {
    var element = ref.current;

    var _ref17 = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {},
        {
      root,
      once,
      amount = "any"
    } = _ref17,
        restArgs = _objectWithoutProperties(_ref17, _excluded5);

    if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
    var activeIntersections = /* @__PURE__ */new WeakMap();

    var onEnter = () => {
      if (to2) {
        api.start(to2);
      }

      setIsInView(true);

      var cleanup = () => {
        if (from) {
          api.start(from);
        }

        setIsInView(false);
      };

      return once ? void 0 : cleanup;
    };

    var handleIntersection = entries => {
      entries.forEach(entry => {
        var onLeave = activeIntersections.get(entry.target);

        if (entry.isIntersecting === Boolean(onLeave)) {
          return;
        }

        if (entry.isIntersecting) {
          var newOnLeave = onEnter();

          if (is12.fun(newOnLeave)) {
            activeIntersections.set(entry.target, newOnLeave);
          } else {
            observer.unobserve(entry.target);
          }
        } else if (onLeave) {
          onLeave();
          activeIntersections.delete(entry.target);
        }
      });
    };

    var observer = new IntersectionObserver(handleIntersection, _objectSpread({
      root: root && root.current || void 0,
      threshold: typeof amount === "number" || Array.isArray(amount) ? amount : defaultThresholdOptions[amount]
    }, restArgs));
    observer.observe(element);
    return () => observer.unobserve(element);
  }, [intersectionArguments]);

  if (propsFn) {
    return [ref, springs];
  }

  return [ref, isInView];
} // src/components/Spring.tsx


function Spring(_ref18) {
  var {
    children
  } = _ref18,
      props = _objectWithoutProperties(_ref18, _excluded6);

  return children(useSpring(props));
} // src/components/Trail.tsx


import { is as is13 } from "@react-spring/shared";

function Trail(_ref19) {
  var {
    items,
    children
  } = _ref19,
      props = _objectWithoutProperties(_ref19, _excluded7);

  var trails = useTrail(items.length, props);
  return items.map((item, index) => {
    var result = children(item, index);
    return is13.fun(result) ? result(trails[index]) : result;
  });
} // src/components/Transition.tsx


function Transition(_ref20) {
  var {
    items,
    children
  } = _ref20,
      props = _objectWithoutProperties(_ref20, _excluded8);

  return useTransition(items, props)(children);
} // src/interpolate.ts


import { deprecateInterpolate as deprecateInterpolate2 } from "@react-spring/shared"; // src/Interpolation.ts

import { is as is14, raf as raf5, each as each10, isEqual as isEqual2, toArray as toArray5, frameLoop as frameLoop3, getFluidValue as getFluidValue3, createInterpolator, Globals as G6, callFluidObservers as callFluidObservers3, addFluidObserver as addFluidObserver3, removeFluidObserver as removeFluidObserver2, hasFluidValue as hasFluidValue2 } from "@react-spring/shared";
import { getAnimated as getAnimated3, setAnimated as setAnimated2, getAnimatedType as getAnimatedType2, getPayload as getPayload2 } from "@react-spring/animated";
var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    /** Equals false when in the frameloop */

    this.idle = true;
    /** The inputs which are currently animating */

    this._active = /* @__PURE__ */new Set();
    this.calc = createInterpolator(...args);

    var value = this._get();

    var nodeType = getAnimatedType2(value);
    setAnimated2(this, nodeType.create(value));
  }

  advance(_dt) {
    var value = this._get();

    var oldValue = this.get();

    if (!isEqual2(value, oldValue)) {
      getAnimated3(this).setValue(value);

      this._onChange(value, this.idle);
    }

    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }

  _get() {
    var inputs = is14.arr(this.source) ? this.source.map(getFluidValue3) : toArray5(getFluidValue3(this.source));
    return this.calc(...inputs);
  }

  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each10(getPayload2(this), node => {
        node.done = false;
      });

      if (G6.skipAnimation) {
        raf5.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop3.start(this);
      }
    }
  } // Observe our sources only when we're observed.


  _attach() {
    var priority = 1;
    each10(toArray5(this.source), source => {
      if (hasFluidValue2(source)) {
        addFluidObserver3(source, this);
      }

      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }

        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;

    this._start();
  } // Stop observing our sources once we have no observers.


  _detach() {
    each10(toArray5(this.source), source => {
      if (hasFluidValue2(source)) {
        removeFluidObserver2(source, this);
      }
    });

    this._active.clear();

    becomeIdle(this);
  }
  /** @internal */


  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);

        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray5(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
  }

};

function isIdle(source) {
  return source.idle !== false;
}

function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}

function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each10(getPayload2(self), node => {
      node.done = true;
    });
    callFluidObservers3(self, {
      type: "idle",
      parent: self
    });
  }
} // src/interpolate.ts


var to = function to(source) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  return new Interpolation(source, args);
};

var interpolate = function interpolate(source) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }

  return deprecateInterpolate2(), new Interpolation(source, args);
}; // src/globals.ts


import { Globals, frameLoop as frameLoop4, createStringInterpolator } from "@react-spring/shared";
Globals.assign({
  createStringInterpolator,
  to: (source, args) => new Interpolation(source, args)
});
var update = frameLoop4.advance; // src/index.ts

import { createInterpolator as createInterpolator2, useIsomorphicLayoutEffect as useIsomorphicLayoutEffect8, useReducedMotion, easings as easings2 } from "@react-spring/shared";
export * from "@react-spring/types";
export { BailSignal, Controller, FrameValue, Globals, Interpolation, Spring, SpringContext, SpringRef, SpringValue, Trail, Transition, config, createInterpolator2 as createInterpolator, easings2 as easings, inferTo, interpolate, to, update, useChain, useInView, useIsomorphicLayoutEffect8 as useIsomorphicLayoutEffect, useReducedMotion, useResize, useScroll, useSpring, useSpringRef, useSpringValue, useSprings, useTrail, useTransition };